<app-marketplace-header-atom
  title="Tout Food Society"
  (backEvent)="onBackButtonClick()"
  subtitle="Les 10 restaurants en 1 carte"
  imgUrl="assets/images/food-society/marketplace-header-background.jpg"
></app-marketplace-header-atom>

<div *ngIf="isMarketplaceAvailable$ | async; else notAvailable">
  <div
    *ngIf="categoryBlocks; else loading"
    appScrollSpy
    [ids]="idsCategories"
    [activeSection]="tab.id"
    (activeSectionChange)="$event && onTabClick({ tabId: $event })"
  >
    <div
      class="sticky top-0 z-10"
      #categoryTabsContainer
    >
      <app-tab-list-atom
        [treeTabs]="tabCategories"
        [activeItemId]="tab.id"
        (tabChange)="onTabClick($event)"
      ></app-tab-list-atom>
    </div>
    <ng-container *ngFor="let categoryBlock of categoryBlocks">
      <app-component-factory
        [componentClass]="categoryBlock.componentClass"
        [data]="categoryBlock"
      ></app-component-factory>
    </ng-container>
  </div>

  <ng-template #loading>
    <div class="pt-8">
      <ng-container *ngFor="let i of [].constructor(200)">
        <div class="flex h-32 max-w-screen-sm cursor-pointer justify-between bg-white px-5 py-3">
          <div class="w-full">
            <p class="mb-2 h-6 w-32 animate-pulse rounded bg-neutral-200"></p>
            <p class="mb-2 h-4 w-44 animate-pulse rounded bg-neutral-50"></p>
          </div>
          <div class="height-fit-content relative">
            <div class="h-28 w-28 animate-pulse rounded bg-neutral-50"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>

<ng-template #notAvailable>
  <div class="mx-auto my-5 max-w-screen-sm px-5 py-5">
    <p class="rounded rounded-sm bg-highlight-50 p-4 font-accent">
      {{ 'shop-page.order-not-available' | translate }}
    </p>
  </div>
</ng-template>
